//
// locale_nl.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/nl.json';
import localeData from "react-intl/locale-data/nl.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
